import React, { useState } from 'react';
import {
  MarketShell, useMarketData, LineChartBox, BarChartBox,
} from './_shared';
import { ChartSection, CHART_PALETTE, formatAUD } from '../charts/shared';

const SERVICES = ['RAISEREG', 'LOWERREG', 'RAISE6SEC', 'RAISE60SEC', 'RAISE5MIN', 'LOWER6SEC', 'LOWER60SEC', 'LOWER5MIN'];

const fmtDay = (iso) =>
  new Date(iso + 'T00:00:00').toLocaleDateString('en-AU', { day: '2-digit', month: 'short' });
const fmtMon = (ym) => {
  const [y, m] = ym.split('-');
  return new Date(+y, +m - 1, 1).toLocaleDateString('en-AU', { month: 'short', year: '2-digit' });
};

export default function MarketFcas() {
  const [days, setDays] = useState(365);
  const { data, loading, error } = useMarketData('fcas', days);

  let body = null;
  if (data) {
    const prices = data.prices || [];
    const x = prices.map((p) => fmtDay(p.date));
    const priceSeries = SERVICES.map((svc, i) => ({
      data: prices.map((p) => p[svc]),
      label: svc,
      color: CHART_PALETTE[i % CHART_PALETTE.length],
      showMark: false, curve: 'linear', connectNulls: true,
    }));

    // Aggregate payments to month × service for a readable stacked bar
    const spend = data.spend || [];
    const months = [...new Set(spend.map((s) => s.date.slice(0, 7)))].sort();
    const svcKeys = [...new Set(spend.map((s) => s.service))].sort();
    const spendSeries = svcKeys.map((svc, i) => ({
      label: svc,
      color: CHART_PALETTE[i % CHART_PALETTE.length],
      data: months.map((mo) =>
        spend.filter((s) => s.service === svc && s.date.slice(0, 7) === mo)
          .reduce((a, s) => a + (s.payment || 0), 0)),
    }));

    body = (
      <>
        <ChartSection title="FCAS prices by service"
          subtitle="Dispatch FCAS RRP (NSW reference region), daily mean (A$/MW/h)">
          <LineChartBox x={x} series={priceSeries} yFormat={(v) => `$${v}`} />
        </ChartSection>

        <ChartSection title="Ancillary-services payments by service"
          subtitle="SET_ANCILLARY_SUMMARY settled payments, aggregated by month (A$)">
          <BarChartBox x={months.map(fmtMon)} series={spendSeries} stacked
            yFormat={formatAUD} height={340} />
        </ChartSection>
      </>
    );
  }

  return (
    <MarketShell
      title="FCAS Market"
      subtitle="Frequency control ancillary services — prices and settled cost (real AEMO actuals)"
      days={days} setDays={setDays} loading={loading} error={error}
    >
      {body}
    </MarketShell>
  );
}
